<span class='page--building-level-real-estate-transactions-page--market-data-overview-desktop--pie-chart-legend-item'>
	<span class='page--building-level-real-estate-transactions-page--market-data-overview-desktop--pie-chart-legend-item-name'><%= name %></span>
	<span class='page--building-level-real-estate-transactions-page--market-data-overview-desktop--pie-chart-legend-item-value'><%= y %></span>
</span>

